import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { ListLayout, TabGroup, Tab } from '@ketch-com/deck'
import { RoutesManager } from 'utils/routing/routesManager'
import { NavigationBreadCrumbs } from 'components/appLayout/appNavigation/breadcrumbs/NavigationBreadCrumbs'
import { HistoricalTab } from './historical/HistoricalTab'
import { DataSentryProvider } from 'pages/dataSentry/context/DataSentryContext'
import { LiveTab } from './live/LiveTab'
import { TrendsTab } from './trends/TrendsTab'

const tabs = [
  { label: 'Live', path: RoutesManager.insights.rights.live.getURL() },
  { label: 'Historical', path: RoutesManager.insights.rights.historical.getURL() },
  { label: 'Trends', path: RoutesManager.insights.rights.trends.getURL() },
]

export const RightsReports = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const breadcrumbs = [
    { title: 'Reports', link: RoutesManager.insights.root.getURL() },
    { title: 'Rights', link: RoutesManager.insights.rights.root.getURL() },
  ]

  const currentTabIndex = Math.max(
    tabs.findIndex(tab => pathname.endsWith(tab.path)),
    0,
  )

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    navigate(tabs[newValue].path)
  }

  return (
    <DataSentryProvider>
      <ListLayout headerTitle="Rights">
        <Box sx={{ width: '1280px', margin: '0px auto' }}>
          <NavigationBreadCrumbs type="light" items={breadcrumbs} />
          <TabGroup value={currentTabIndex} onChange={handleTabChange} tabItems={tabs}>
            {tabs.map(tab => (
              <Tab key={tab.label} label={tab.label} />
            ))}
          </TabGroup>
          {currentTabIndex === 0 && (
            <Box sx={{ pt: 3 }}>
              <LiveTab />
            </Box>
          )}
          {currentTabIndex === 1 && (
            <Box sx={{ pt: 3 }}>
              <HistoricalTab />
            </Box>
          )}
          {currentTabIndex === 2 && (
            <Box sx={{ py: 3 }}>
              <TrendsTab />
            </Box>
          )}
        </Box>
      </ListLayout>
    </DataSentryProvider>
  )
}
